module.exports = __webpack_public_path__ + "media/questions/blue-arrow-cd52a615.png";